import { createFileRoute } from '@tanstack/react-router'
import { DashboardPage } from '@/pages/dashboard'
import PageLoading from '@/components/PageLoading'

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/')({
  component: DashboardPage,
  pendingComponent: () => (
    <div>
      <PageLoading />
    </div>
  ),
  pendingMs: 0,
  pendingMinMs: 200,
})
